import { StockService } from './../../../../Services/Stock/stock.service';
import { Component, OnInit } from '@angular/core';
import { NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterLink } from '@angular/router';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';

// Assuming these services exist and are correctly implemented for packaging
import { ApiService } from '../../../../Services/api.service';
import { NotificationService } from '../../../../Services/notification.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-packaging-stack-list',
  imports: [NgFor, FormsModule, NgIf, RouterLink],
  templateUrl: './packaging-stack-list.component.html',
  styleUrl: './packaging-stack-list.component.css'
})
export class PackagingStackListComponent implements OnInit {

  paginatedPackagingList: any[] = [];
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 0;

  packagingList: any[] = [];
  startDate: string = '';
endDate: string = '';
filteredPackagingStackList: any[] = [];
  globalSearchText: any;
  searchValues: { [key: string]: string } = {};
  sortKey: string = '';
  sortDirection: 'asc' | 'desc' = 'asc';

  showDropdown: boolean = false;
  visibleRowCount: any;

  selectedFields = [
    { key: 'st_item_name', label: 'Name', selected: true },
    { key: 'st_item_code', label: 'Packaging Code', selected: true },
    { key: 'st_item_category', label: ' Category', selected: true, subKey: 'name' },
    // { key: 'st_quantity', label: 'Quantity', selected: true },
    { key: 'st_unit_price', label: 'Price', selected: true },
    { key: 'st_final_valuation', label: 'final value', selected: true },
    // { key: 'st_product_code_type', label: 'Packaging Type', selected: true },
    // { key: 'st_supplier_code', label: 'Supplier Code', selected: true },
    // { key: 'st_supplier_bill_no', label: 'bill no ', selected: true },
    // { key: 'st_packaging_date', label: 'Packaging date', selected: true },
    { key: 'st_minor_packaging_items', label: 'Minor Items', selected: true },
  ];

  constructor(
    private apiService: ApiService,
    private notificationService: NotificationService,
    private StockService: StockService
  ) {}

  ngOnInit(): void {
    const savedSelections = localStorage.getItem('packagingColumnSelections');
    if (savedSelections) {
      this.selectedFields = JSON.parse(savedSelections);
    }
    this.getPackagingList();
    this.filterTable(); // Call filterTable after data is loaded and selections are restored
  }

  // --- Data Retrieval and Pagination ---

  getPackagingList() {
    this.StockService.getStockEntries().subscribe((response: any) => {
      if (response?.data?.length) {
        this.packagingList = response.data
          .filter((item: any) => item.st_product_code_type === 'Packaging Stack')
          .map((item: any) => ({
            ...item,
            // 🔥 PARSE minor items safely
            st_minor_packaging_items: item.st_minor_packaging_items
  ? JSON.parse(item.st_minor_packaging_items).map((m: any) => ({
      minor_name: m.minor_name ?? m.st_item_name ?? '-',
      minor_cost: m.minor_cost ?? m.st_item_cost ?? 0,
    }))
  : []

          }))
          .sort((a: any, b: any) => b.id - a.id);

        this.totalPages = Math.ceil(this.packagingList.length / this.itemsPerPage);
        this.currentPage = 1;
        this.filterTable();
      } else {
        this.packagingList = [];
        this.paginatedPackagingList = [];
        this.totalPages = 0;
      }
    });
  }

  updatePaginatedList() {
    const start = (this.currentPage - 1) * this.itemsPerPage;
    const end = start + this.itemsPerPage;
    this.paginatedPackagingList = this.packagingList.slice(start, end);
  }



 filterTable() {

  if (!this.packagingList) return;

  let filtered = this.packagingList.filter((item: any) => {

    /* ================= DATE FILTER ================= */

    if (this.startDate || this.endDate) {

      const itemDateRaw = item['created_at']; // ✅ use created_at

      if (!itemDateRaw) return false;

      const itemDate = new Date(itemDateRaw)
        .toISOString()
        .split('T')[0];

      if (this.startDate && itemDate < this.startDate) {
        return false;
      }

      if (this.endDate && itemDate > this.endDate) {
        return false;
      }
    }

    /* ================= COLUMN FILTER ================= */

    const matchesFieldFilters = this.selectedFields.every(field => {

      const searchTerm = (this.searchValues[field.key] || '')
        .trim()
        .toLowerCase();

      if (!searchTerm) return true;

      const fieldValue = (item[field.key] ?? '')
        .toString()
        .toLowerCase();

      return fieldValue.includes(searchTerm);
    });

    /* ================= GLOBAL SEARCH ================= */

    const matchesGlobalSearch = this.globalSearchText
      ? Object.values(item).some(val =>
          (val ?? '')
            .toString()
            .toLowerCase()
            .includes(this.globalSearchText.trim().toLowerCase())
        )
      : true;

    return matchesFieldFilters && matchesGlobalSearch;
  });

  /* ================= SORT ================= */

  if (this.sortKey) {
    filtered.sort((a: any, b: any) => {

      const valA = a[this.sortKey] ?? '';
      const valB = b[this.sortKey] ?? '';

      return this.sortDirection === 'asc'
        ? valA > valB ? 1 : valA < valB ? -1 : 0
        : valA < valB ? 1 : valA > valB ? -1 : 0;
    });
  }

  /* ================= SAVE FILTERED ================= */

  this.filteredPackagingStackList = filtered;

  /* ================= PAGINATION ================= */

  this.totalPages = Math.ceil(filtered.length / this.itemsPerPage);

  if (this.currentPage > this.totalPages && this.totalPages > 0) {
    this.currentPage = this.totalPages;
  }

  const start = (this.currentPage - 1) * this.itemsPerPage;

  this.paginatedPackagingList = filtered.slice(
    start,
    start + this.itemsPerPage
  );
}


  sortBy(key: string) {
    if (this.sortKey === key) {
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    } else {
      this.sortKey = key;
      this.sortDirection = 'asc';
    }
    this.filterTable();
  }

  // --- Column Visibility and Persistence ---

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  applyColumnSelection() {
    localStorage.setItem('packagingColumnSelections', JSON.stringify(this.selectedFields));
    this.showDropdown = false;
    this.filterTable(); // Re-filter to update visible columns in the table
  }

  selectAllFields() {
    this.selectedFields.forEach((field) => (field.selected = true));
    this.saveSelectedFields();
    this.filterTable();
  }

  deselectAllFields() {
    this.selectedFields.forEach((field) => (field.selected = false));
    this.saveSelectedFields();
    this.filterTable();
  }

  restoreColumnSelection() {
    localStorage.removeItem('packagingColumnSelections');
    // Reset to default selected fields
    this.selectedFields = [
      { key: 'st_item_name', label: 'ID', selected: true },
      { key: 'st_item_category', label: ' Category', selected: true, subKey: 'name'},
      { key: 'st_item_code', label: 'item code', selected: true },
      { key: 'st_quantity', label: 'Quantity', selected: true },
      { key: 'st_unit_price', label: 'Price', selected: true },
      { key: 'st_final_valuation', label: 'final value', selected: true },
      // { key: 'st_product_code_type', label: 'Type', selected: true },
      { key: 'st_supplier_code', label: 'Supplier Code', selected: true },
      { key: 'st_packaging_date', label: 'Packaging date', selected: true },
      { key: 'st_supplier_bill_no', label: 'bill no ', selected: true },
    ];
    this.filterTable();
  }

  onFieldToggle(field: any) {
    field.selected = !field.selected;
    this.saveSelectedFields();
    this.filterTable();
  }

  saveSelectedFields() {
    localStorage.setItem('packagingColumnSelections', JSON.stringify(this.selectedFields));
  }

  get selectedFieldss() { // Renamed to avoid conflict if `selectedFields` is also used as a getter elsewhere
    return this.selectedFields.filter((field) => field.selected);
  }

  // --- Pagination Controls ---

  onPageChange(page: number) {
    this.currentPage = page;
    this.filterTable();
  }

  goToPage(page: number) {
    if (page >= 1 && page <= this.totalPages) {
      this.currentPage = page;
      this.filterTable();
    }
  }

  goToPreviousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.filterTable();
    }
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.filterTable();
    }
  }

  get pageNumbers(): number[] {
    // Generate an array of page numbers to display in pagination controls
    const pages: number[] = [];
    const maxPagesToShow = 5; // Adjust as needed
    let startPage = Math.max(1, this.currentPage - Math.floor(maxPagesToShow / 2));
    let endPage = Math.min(this.totalPages, startPage + maxPagesToShow - 1);

    if (endPage - startPage + 1 < maxPagesToShow) {
      startPage = Math.max(1, endPage - maxPagesToShow + 1);
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  }

  // --- Export and Print Functionality ---
formatMinorItems(items: any[]): string {
  if (!items || !items.length) return '-';

  return items
    .map(i => {
      const name = i.minor_name || '-';
      const cost = Number(i.minor_cost || 0).toFixed(2);
      return `• ${name} : Rs. ${cost}`;
    })
    .join('\n');
}


  downloadPDF(): void {
  const doc = new jsPDF({
    orientation: 'landscape',
    unit: 'mm',
    format: 'a3',
  });

  const selectedFields = this.selectedFields.filter(f => f.selected);

  if (!selectedFields.length) {
    this.notificationService.showError(
      'Please select at least one column',
      'Error'
    );
    return;
  }

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  /* ================= HEADER ================= */

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(14);
  doc.text('Packaging Stack List', pageWidth / 2, 14, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.text(
    `Generated on: ${new Date().toLocaleString()}`,
    pageWidth - 10,
    10,
    { align: 'right' }
  );

  /* ================= TABLE ================= */

  const headers = [
    { header: 'No.', dataKey: 'no' },
    ...selectedFields.map(f => ({
      header: f.label,
      dataKey: f.key,
    })),
  ];

  const sourceData = this.getExportSourceData();

const body = sourceData.map((item, index) => {
    const row: any = {
      no: (this.currentPage - 1) * this.itemsPerPage + index + 1,
    };

    selectedFields.forEach(f => {
      let value = item[f.key];

      if (f.key === 'st_minor_packaging_items') {
        value = this.formatMinorItems(value);
      } else if (f.subKey && typeof value === 'object') {
        value = value?.[f.subKey];
      }

      row[f.key] = value ?? '-';
    });

    return row;
  });

  autoTable(doc, {
    columns: headers,
    body,

    startY: 20,

    horizontalPageBreak: false,
    rowPageBreak: 'auto',

    tableWidth: pageWidth - 14,

    styles: {
      fontSize: 6.5,
      cellPadding: 1.4,
      overflow: 'linebreak',
      valign: 'middle',
    },

    headStyles: {
      fillColor: [193, 151, 37],
      textColor: 255,
      halign: 'center',
      fontStyle: 'bold',
      fontSize: 7,
    },

    columnStyles: {
  no: { halign: 'center', cellWidth: 10 },
  st_minor_packaging_items: {
    cellWidth: 60,
    halign: 'left',
  },
},


    didDrawPage: () => {
      doc.setFontSize(8);
      doc.text(
        `Page ${(doc as any).getNumberOfPages()}`,
        pageWidth / 2,
        pageHeight - 8,
        { align: 'center' }
      );
    },
  });

  doc.save('packaging-stack-list.pdf');
}


  downloadExcel(): void {
  const selectedFields = this.selectedFields.filter(field => field.selected);

  const numericKeys = [
    'st_quantity',
    'st_unit_price',
    'st_final_valuation'
  ];

  const sourceData = this.getExportSourceData();

const data = sourceData.map((item, index) => {
    const row: any = {
      'No.': (this.currentPage - 1) * this.itemsPerPage + index + 1
    };

    selectedFields.forEach(field => {
      let value: any;

      if (field.subKey) {
        value = item[field.key]?.[field.subKey];
      }

      // 👇 formatted text column
      else if (field.key === 'st_minor_packaging_items') {
        value = this.formatMinorItems(item.st_minor_packaging_items);
      }

      // normal
      else {
        value = item[field.key];
      }

      if (numericKeys.includes(field.key)) {
        value =
          value !== null &&
          value !== undefined &&
          value !== ''
            ? parseFloat(value)
            : 0;
      }

      row[field.label] = value;
    });

    // ⭐ ADD NUMERIC TOTAL COLUMN
    row['Minor Items Total'] =
      this.getMinorItemsTotal(item.st_minor_packaging_items);

    return row;
  });

  const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);

  Object.keys(worksheet).forEach(cell => {
    if (cell.startsWith('!')) return;

    const c = worksheet[cell];
    if (typeof c.v === 'number') {
      c.t = 'n';
    }
  });

  const workbook: XLSX.WorkBook = {
    Sheets: { 'Packaging List': worksheet },
    SheetNames: ['Packaging List']
  };

  const excelBuffer = XLSX.write(workbook, {
    bookType: 'xlsx',
    type: 'array'
  });

  FileSaver.saveAs(
    new Blob([excelBuffer], {
      type:
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }),
    'packaging-stack-list.xlsx'
  );
}


getMinorItemsTotal(items: any[]): number {
  if (!items || !items.length) return 0;

  return items.reduce(
    (sum, i) => sum + Number(i.minor_cost || 0),
    0
  );
}


  downloadJSONAll(): void {
    const data = this.getExportSourceData();

    const jsonString = JSON.stringify(data, null, 2);

    const blob = new Blob([jsonString], { type: 'application/json' });
    const fileName = 'packaging-list.json';

    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(link.href);
  }

  downloadCSV(): void {
   const data = this.getExportSourceData();

    if (!data.length) return;

    const selectedFields = this.selectedFields?.filter(f => f.selected) || [];
    const headers = ['No.', ...selectedFields.map(f => f.label)];
    const keys = selectedFields.map(f => f.key);

    let csvContent = headers.join(',') + '\n';

    data.forEach((item, index) => {
      const row = [
        (this.currentPage - 1) * this.itemsPerPage + index + 1,
        ...keys.map(key => {
          const value = item[key];
          return typeof value === 'string' && value.includes(',')
            ? `"${value}"`
            : value ?? '';
        }),
      ];
      csvContent += row.join(',') + '\n';
    });

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    const fileName = 'packaging-list.csv';

    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', fileName);
    link.click();

    URL.revokeObjectURL(link.href);
  }

 printTable() {

  console.log('DEBUG packaging row:', this.paginatedPackagingList[0]);

  let printContent = `
  <html>
  <head>
    <title>Packaging Stack List</title>

    <style>

  body {
    font-family: Arial, sans-serif;
  }

  table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 12px;
  }

  /* =============================
     MAIN TABLE GRID (STRONG)
  ============================== */

  th, td {
    border-right: 2px solid #000;
    border-bottom: 2px solid #000;
    padding: 6px;
    text-align: center;
    vertical-align: middle;
    word-break: break-word;
  }

  th:first-child,
  td:first-child {
    border-left: 2px solid #000;
  }

  thead th {
    border-top: 2px solid #000;
    background: #f2f2f2;
    font-weight: bold;
  }

  tbody tr:last-child td {
    border-bottom: 2px solid #000;
  }

  /* =============================
     MINOR ITEMS INNER TABLE
  ============================== */

  .minor-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 11px;
  }

  .minor-table th,
  .minor-table td {
    border: 1.5px solid #000;
    padding: 3px;
  }

  /* =============================
     PRINT SAFETY
  ============================== */

  @media print {

    @page {
      size: auto;
      margin: 10mm;
    }

    * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
    }

    body {
      margin: 0;
    }

    thead {
      display: table-header-group;
    }

    tr {
      page-break-inside: avoid;
    }

  }

</style>

  </head>
  <body>

    <h3>Packaging Stack List</h3>

    <table>
      <thead>
        <tr>
          <th>No.</th>
  `;

  // ===== HEADERS =====
  this.selectedFields.forEach(field => {
    if (field.selected) {
      printContent += `<th>${field.label}</th>`;
    }
  });

  printContent += `
        </tr>
      </thead>
      <tbody>
  `;

  // ===== ROWS =====
  const data = this.getExportSourceData();
  data.forEach((item, index) => {

    printContent += `
      <tr>
        <td>${(this.currentPage - 1) * this.itemsPerPage + index + 1}</td>
    `;

    this.selectedFields.forEach(field => {

      if (!field.selected) return;

      const value = item[field.key];

      let displayValue = '';

      /* ======================
         CATEGORY OBJECT
      ====================== */
      if (field.key === 'st_item_category' && value) {

        displayValue = value.name || '';

      }

      /* ======================
         ✅ MINOR ITEMS FIX
      ====================== */
      else if (field.key === 'st_minor_packaging_items') {

        const minorArr = value || [];

        if (Array.isArray(minorArr) && minorArr.length) {

          displayValue = `
            <table class="minor-table">
              <tr>
                <th>Item</th>
                <th>Cost</th>
              </tr>

              ${minorArr.map((mi: any) => `
                <tr>
                  <td>${mi.minor_name || '-'}</td>
                  <td>${mi.minor_cost || '0'}</td>
                </tr>
              `).join('')}

            </table>
          `;

        } else {

          displayValue = '';

        }

      }

      /* ======================
         OTHER OBJECT
      ====================== */
      else if (value && typeof value === 'object') {

        displayValue = value.name || '';

      }

      /* ======================
         NORMAL VALUE
      ====================== */
      else {

        displayValue = value ?? '';

      }

      printContent += `<td>${displayValue}</td>`;

    });

    printContent += `</tr>`;

  });

  printContent += `
      </tbody>
    </table>

  </body>
  </html>
  `;

  const printWindow = window.open('', '_blank');

  if (printWindow) {
    printWindow.document.open();
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
  }
}


  openPackagingDetails(id: number): void {
    this.StockService.getStockEntryById(id).subscribe(
      (response: any) => {
        const packaging = response.data;

        // Dynamically generate rows based on selected fields
        const rows = this.selectedFields
          .filter(field => field.selected)
          .map(field => {
            const value = packaging[field.key] ?? '-';
            return `<p><strong>${field.label}:</strong> ${value}</p>`;
          })
          .join('');

        Swal.fire({
          title: `<strong style="font-size: 20px; color: #c19725;">Packaging Details</strong>`,
          html: `
            <div style="text-align: left; font-size: 14px; max-height: 70vh; overflow-y: auto; font-family: 'Segoe UI', sans-serif;">
              <section style="margin-bottom: 1.5rem;">
                <h3 style="background: #fdf5e4; color: #c19725; padding: 6px 10px; border-left: 4px solid #c19725;">Item Info</h3>
                <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding-top: 8px;">
                  ${rows}
                </div>
              </section>
            </div>
          `,
          showCloseButton: true,
          focusConfirm: false,
          confirmButtonText: '<span style="color: white;">Close</span>',
          width: '650px',
          scrollbarPadding: false,
          customClass: {
            popup: 'packaging-details-popup',
            confirmButton: 'packaging-confirm-button'
          }
        });
      },
      (error) => {
        console.error('Error fetching packaging details', error);
        Swal.fire('Error', 'Unable to fetch packaging details. Please try again.', 'error');
      }
    );
  }


  deletePackaging(id: any) {
    this.apiService.delete(`stocks/${id}`).subscribe(
      (response: any) => {
        this.notificationService.showSuccess('Packaging item deleted successfully!', 'Success');
        this.getPackagingList();
      },
      (error: any) => {
        this.notificationService.showError('Failed to delete packaging item. Please try again.', 'Error');
      }
    );
  }
  private getExportSourceData(): any[] {

  const hasFilter =
    this.startDate ||
    this.endDate ||
    this.globalSearchText ||
    Object.values(this.searchValues).some(v => v);

  return hasFilter
    ? this.filteredPackagingStackList
    : this.packagingList;
}

}
